module.exports = __webpack_public_path__ + "static/media/vocab_icon.663550b7.png";